import React from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  withGlow?: boolean;
  glowPosition?: 'center' | 'top';
}
export function SectionWrapper({
  children,
  className = '',
  id,
  withGlow = false,
  glowPosition = 'center'
}: SectionWrapperProps) {
  const {
    ref,
    isVisible
  } = useScrollAnimation({
    threshold: 0.1
  });
  const glowClass = withGlow ? glowPosition === 'top' ? 'radial-glow-top' : 'radial-glow' : '';
  return <section id={id} ref={ref} className={`
        relative w-full
        ${glowClass}
        ${className}
      `} data-id="element-549">
      <div className="gold-divider w-full" data-id="element-550" />
      <div className={`
          max-w-6xl mx-auto px-5 md:px-8 py-16 md:py-24 lg:py-32
          transition-all duration-1000 ease-out
          ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}
        `} data-id="element-551">
        {children}
      </div>
    </section>;
}